import { translatableStringFactory } from "@@/shared/translations/translation";
import { kebabCase } from "@@/utilities/casing";
import { z } from "zod";

type IconName = string;
const iconNameZodString = z.string().refine(
    value => kebabCase(value).toLowerCase() === value,
    translatableStringFactory({
        en: "Icon name must be in lower kebab case",
        sv: "Ikonnamnet måste vara angivet med små bokstäver och bindestreck istället för mellanslag",
    }),
);

export { iconNameZodString };
export type { IconName };
